// extracted by mini-css-extract-plugin
var _1 = "rGOnn";
var _2 = "JRk8I";
var _3 = "dtwv9";
var _4 = "y2rPv";
var _5 = "dBkXg";
export { _1 as "base", _2 as "fullDataMessage", _3 as "message", _4 as "theme-dark", _5 as "theme-light" }
